import { useEffect, useState } from "react";
import { Web3Auth } from "@web3auth/modal";
import { EthereumPrivateKeyProvider } from "@web3auth/ethereum-provider";
import localeText from "../../../../../locale";
// import { CHAIN_NAMESPACES } from "@web3auth/base";
import Web3 from "web3";
import { ABI } from "../ABI";
import { useToastContext } from "../../../../../contexts/ToastContext/ToastContext";
import { WEB3AUTH_NETWORK } from "@web3auth/base";
import { MetamaskAdapter } from "@web3auth/metamask-adapter";


const web3 = new Web3("https://bsc-dataseed.binance.org/");

const chainConfig = {
  chainNamespace: "eip155",
  chainId: "0x38", // hex of 56 for BSC Mainnet
  rpcTarget: "https://bsc-dataseed.binance.org", // Avoid using public rpcTarget in production. Use services like Infura, Quicknode etc
  displayName: "Binance SmartChain Mainnet",
  blockExplorer: "https://bscscan.com/token/0x894A56C1276e885ebB369b99E3d154512b4c682c",
  ticker: "BNB",
  tickerName: "Binance Coin",
}


const privateKeyProvider = new EthereumPrivateKeyProvider({
  config: { chainConfig: chainConfig },
});

const clientId = process.env.REACT_APP_CLIENT_ID_WEB3AUTH;
const metamaskAdapter = new MetamaskAdapter({
  clientId,
  sessionTime: 3600, // 1 hour in seconds
  web3AuthNetwork: "sapphire_mainnet",
  chainConfig: {
    chainNamespace: "eip155",
    chainId: "0x38",
    rpcTarget: "https://bsc-dataseed.binance.org", // This is the public RPC we have added, please pass on your own endpoint while creating an app
  },
});
const tokenContractAddress = "0x894A56C1276e885ebB369b99E3d154512b4c682c";

const useWeb3 = () => {
  const { showErrorToast, showSuccessToast } = useToastContext();
  const contract = new web3.eth.Contract(ABI, tokenContractAddress);

  const [web3auth, setWeb3auth] = useState(null);
  const [provider, setProvider] = useState(null);
  const [cryptoUser, setCryptoUser] = useState(null);
  const [walletAddress, setWalletAddress] = useState(null);
  const [cryptoBalance, setCryptoBalance] = useState(0);
  // const [privateKey, setPrivateKey] = useState(null);
  const [web3loading, setWeb3Loading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [isLoadingInit, setIsLoadingInit] = useState(true);
  const [isLogged, setIsLogged] = useState(false);

  const loginWeb3Auth = async () => {
    try {
      setIsLoadingInit(true);
      if (!web3auth) {
        console.log("web3auth not initialized yet");

        showErrorToast({
          detail: "walletLoginFailed",
        });
        setIsLoadingInit(false);
        return;
      }


      const web3authProvider = await web3auth.connect();
      setProvider(web3authProvider);

      if (web3auth.connected) {

        setIsLogged(true);

        showSuccessToast({
          detail: "walletLogin",
        });
        setIsLoadingInit(false);

      } else {
        showErrorToast({
          detail: "walletLoginFailed",
        });
        setIsLoadingInit(false);
      }
    } catch (error) {
      console.log("error: ", error);
    }
  };

  const logoutWeb3Auth = async () => {
    try {
      setIsLoadingInit(true);

      if (!provider || !isLogged) {
        showErrorToast({
          detail: "youDoNotHaveWalletLogged",
        });
        setIsLoadingInit(false);
        return;
      }

      await web3auth.logout();
      setIsLogged(false);
      setProvider(null);
      setCryptoBalance(0);
      setWalletAddress(null);
      setCryptoUser(null);
      setIsLoadingInit(false);

      showSuccessToast({
        detail: "walletLogout",
      });
    } catch (error) {
      console.log("error: ", error);
    }
  };

  const getUserInfo = async () => {
    if (!web3auth) {
      console.log("web3auth not initialized yet");
      return;
    }

    const user = await web3auth.getUserInfo();

    return user;
  };

  const getChainId = async () => {
    try {
      const web3 = new Web3(provider);

      // Get the connected Chain's ID
      const chainId = await web3.eth.getChainId();

      return chainId.toString();
    } catch (error) {
      return error;
    }
  };

  const getAccounts = async () => {
    try {
      const web3 = new Web3(provider);

      const address = (await web3.eth.getAccounts())[0];

      return address;
    } catch (error) {
      return error;
    }
  };

  async function getBalance() {
    // const balance = await contract.methods.balanceOf(walletAddress).call();
    // const decimals = await contract.methods.decimals().call();
    // console.log(`Balance: ${balance}`);
    // const adjustedBalance = balance / (10 ** decimals);
    // console.log(`Balance: ${adjustedBalance}`);

    const web3 = new Web3(provider);

    // Get user's Ethereum public address
    const address = (await web3.eth.getAccounts())[0];

    const tokenBalance = await contract.methods.balanceOf(address).call(); // Balance is in wei
    const balanceInNumber = Number(tokenBalance);
    const decimals = await contract.methods.decimals().call();
    const decimalsInNumber = Number(decimals);
    const adjustedBalance = balanceInNumber / 10 ** decimalsInNumber;

    return adjustedBalance;
  }

  const simplifiedTransaction = async (valueExc, destinyAddress) => {
    try {
      const web3 = new Web3(provider);
      const userTokenBalance = await getBalance()
      const fromAddress = (await web3.eth.getAccounts())[0];
      const amount = web3.utils.toWei(valueExc, "ether");
      const gasPrice = 0;
      const gasLimit = 500000;
      console.log({
        from: fromAddress,
        to: destinyAddress,
        value: amount,
      })
      const receipt = await web3.eth.sendTransaction(
        {
          from: fromAddress,
          to: destinyAddress,
          value: amount,
        },
        (result) => console.log("result: ", result)
      );

      console.log("receipt: ", receipt);
    } catch (e) {
      console.log(e.data)
      throw e
    }

  }



  const sendTransaction = async (
    value,
    order,
    address,
    city,
    country,
    district,
    number,
    postalCode,
    state
  ) => {
    setWeb3Loading(true);
    console.log("enter func");
    try {
      console.log("enter try");
      if (
        !order.itens[0].product.downloadable &&
        !order.itens[0].product.service &&
        (address.length === 0 ||
          city.length === 0 ||
          country.length === 0 ||
          district.length === 0 ||
          number.length === 0 ||
          postalCode.length === 0 ||
          state.length === 0)
      ) {
        console.log("test fields failed");
        showErrorToast({ detail: "pleaseFillOutAll" });
        setWeb3Loading(false);
        setOpenModal(false);
        return false;
      }

      if (value > cryptoBalance) {
        setWeb3Loading(false);

        showErrorToast({
          detail: "insufficientFunds",
        });
        setOpenModal(false);
        console.log("test balance failed");
        return false;
      }

      const web3 = new Web3(provider);

      // Get user's Ethereum public address
      const fromAddress = (await web3.eth.getAccounts())[0];

      // const destination = fromAddress;

      const amount = web3.utils.toWei(value, "ether"); // Convert 1 ether to wei
      // Submit transaction to the blockchain and wait for it to be mined

      const gasPrice = await web3.eth.getGasPrice();
      const gasLimit = 500000; // remember to remove one zero

      const receipt = await web3.eth.sendTransaction(
        {
          from: fromAddress,
          // to: "0xf717db18BABE57881588B0e5F6568793B8886FA3",
          value: amount,
          gasPrice: gasPrice,
          gasLimit: gasLimit,
        },
        (result) => console.log("result: ", result)
      );

      console.log("receipt: ", receipt);

      if (!receipt?.transactionHash) {
        setWeb3Loading(false);
        showErrorToast({
          summary: "error",
        });
        setOpenModal(false);
        return false;
      }

      showSuccessToast({
        summary: localeText("success"),
      });

      setWeb3Loading(false);
      setOpenModal(false);

      // The code bellow is suppose to be used in the backend
      // const transactionData = await web3.eth.getTransactionReceipt(receipt?.transactionHash);

      // console.log('transactionData: ', transactionData);

      // get the blockData and the timestamp from the transction, so we can see the rate at the moment of the transction

      // const blockData = await web3.eth.getBlock(transactionData?.blockNumber);

      // console.log('blockData: ', new Date(Number(blockData?.timestamp) * 1000));

      // const transcTionValue = await web3.eth.getTransaction(receipt?.transactionHash)

      // console.log('transcTionValue: ', transcTionValue)

      return receipt;
    } catch (error) {
      setWeb3Loading(false);
      setOpenModal(false);
      showErrorToast({
        summary: "error",
      });

      return error;
    }
  };

  // const getPrivateKey = async () => {
  //   try {
  //     const privateKey = await provider.request({
  //       method: "eth_private_key",
  //     });

  //     return privateKey;
  //   } catch (error) {
  //     return error;
  //   }
  // };

  useEffect(() => {
    const init = async () => {
      try {
        setIsLoadingInit(true);
        // const web3auth = new Web3Auth({
        //   clientId,
        //   web3AuthNetwork: process.env.REACT_APP_WEB3AUTHNETWORK,
        //   chainConfig: {
        //     chainNamespace: "eip155",
        //     chainId: "0x38", // hex of 56 for BSC Mainnet
        //     rpcTarget: "https://rpc.ankr.com/bsc", // Avoid using public rpcTarget in production. Use services like Infura, Quicknode etc
        //     displayName: "Binance SmartChain Mainnet",
        //     blockExplorer: "https://bscscan.com/token/0x894A56C1276e885ebB369b99E3d154512b4c682c",
        //     ticker: "BNB",
        //     tickerName: "Binance Coin",
        //   },
        // });

        //tbnb srmat chain testnet
        const web3auth = new Web3Auth({
          clientId,
          web3AuthNetwork: WEB3AUTH_NETWORK.SAPPHIRE_DEVNET,
          uiConfig: {
            appName: "W3A",
            theme: {
              primary: "red",
            },
            mode: "dark",
            logoLight: "https://extraconomy.com/static/media/logo-color-horizontal.05fe6ab611037d6aaf49.png",
            logoDark: "https://extraconomy.com/static/media/logo-color-horizontal.05fe6ab611037d6aaf49.png",
            defaultLanguage: "en", // en, de, ja, ko, zh, es, fr, pt, nl
            loginGridCol: 3,
            primaryButton: "externalLogin", // "externalLogin" | "socialLogin" | "emailLogin"
          },
          privateKeyProvider
        });
        web3auth.configureAdapter(metamaskAdapter);

        // const web3auth = new Web3Auth({
        //   clientId,
        //   web3AuthNetwork: "testnet",
        //   chainConfig: {
        //     chainNamespace: "eip155",
        //     chainId: "0x5", // hex of 56 for BSC Mainnet
        //     rpcTarget: "https://goerli.blockpi.network/v1/rpc/public", // Avoid using public rpcTarget in production. Use services like Infura, Quicknode etc
        //     displayName: "GoerliETH",
        //     blockExplorer: "https://testnet.bscscan.com/",
        //     ticker: "ETH",
        //     tickerName: "ETH",
        //   },
        // });

        setWeb3auth(web3auth);

        await web3auth.initModal();

        if (web3auth.provider && web3auth.connected) {

          setProvider(web3auth.provider);


        }
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoadingInit(false);
      }
    };

    init();
  }, []);

  useEffect(() => {
    (async () => {
      if (provider) {
        const address = await getAccounts();

        setWalletAddress(address);

        const cryptoUser = await getUserInfo();
        setCryptoUser(cryptoUser);

        const balance = await getBalance();

        setCryptoBalance(balance);

        setIsLogged(true);

        // const privateKey = await getPrivateKey();

        // setPrivateKey(privateKey);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [web3auth, provider]);

  return {
    walletAddress,
    cryptoBalance,
    cryptoUser,
    //  privateKey,
    web3loading,
    openModal,
    provider,
    loginWeb3Auth,
    logoutWeb3Auth,
    sendTransaction,
    getChainId,
    setOpenModal,
    isLoadingInit,
    isLogged,
    simplifiedTransaction
  };
};

export default useWeb3;
